import { motion } from 'framer-motion'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'components/constants/animation-properties';
import Background from 'assets/main/fifth.avif'
import Box from 'assets/main/fifthBox.avif'
import Container from 'components/common/Container';
import CustomButton from 'components/common/CustomButton';
import { useNavigate } from 'react-router-dom';
import { useGetUser } from 'atom/user';
import { toast } from 'react-toastify';
import { useContext } from 'react';
import { GlobalContext } from 'App';

const Eighth = () => {
    const { isTablet } = useContext(GlobalContext);
    const user = useGetUser();

    const navigate = useNavigate();
    const goSignup = () => {
        if (user.id) {
            toast.error('마이페이지로 이동 시키든 해야함');
        }
        else {
            navigate('/signup');
        }
    }

    return (
        <div
            className='flex flex-col items-center py-[146px] mobile:py-20 text-white'
            style={{ background: `url(${Background}) no-repeat center center / cover` }}
        >
            <Container>
                {
                    isTablet ?
                        <motion.div
                            initial={START_ANIMATION_PROPERTY}
                            whileInView={END_ANIMATION_PROPERTY}
                            viewport={VIEWPORT_PROPERTY}
                            className='flex flex-col justify-center items-center gap-7.5 bg-[rgba(0,0,0,0.5)] px-3 py-6 rounded'
                        >
                            <h2 className='font-bold text-xl text-center'>
                                디지털 토탈 물류 솔루션 PulseOnShip<br />
                                지금 바로 시작하세요
                            </h2>
                            {
                                !user.id &&
                                <CustomButton
                                    onClick={goSignup}
                                    className='bg-primary !px-0 !py-0 !rounded-full w-[300px] min-w-[100px] font-normal text-xl'
                                    title='무료 회원 가입하기'
                                />
                            }
                        </motion.div> :
                        <motion.div
                            initial={START_ANIMATION_PROPERTY}
                            whileInView={END_ANIMATION_PROPERTY}
                            viewport={VIEWPORT_PROPERTY}
                            className='flex flex-col justify-center items-center gap-7.5 py-19'
                            style={{ background: `url(${Box}) center/contain no-repeat` }}
                        >
                            <h2 className='font-bold text-[3.125rem] text-center'>
                                디지털 토탈 물류 솔루션 PulseOnShip<br />
                                지금 바로 시작하세요
                            </h2>
                            {
                                !user.id ?
                                    <CustomButton
                                        onClick={goSignup}
                                        className='bg-primary !px-0 !py-0 !rounded-full w-[300px] min-w-[100px] font-normal text-xl'
                                        title='무료 회원 가입하기'
                                    /> :
                                    <div className='w-[300px] h-10'></div>
                            }
                        </motion.div>
                }
            </Container>
        </div>
    )
}

export default Eighth